import React, { useEffect, useState } from 'react'
import { Image } from 'react-bootstrap'
import { useQuery } from 'react-query'
import { connect, useDispatch, useSelector } from 'react-redux'

import ColetaClickstream from '../../components/clickstreamAnalise/clickstreamColeta.js'
import SpinerVeye from '../../components/spinnerVeye/spinnerVeye.js'
import { api_gateway } from '../../conexoes/api'
import {
  desabilitarAcoes,
  desabilitarAcoesCliente,
  limpadorFiltros,
  limpouBusca,
  mudarFiltros,
  mudarManejador,
  mudarPermissaoElementoAcao,
  realizouBusca,
  realizouFiltro,
  revelarBarraFiltragem,
  revelarExcluirUsuarioCliente,
  revelarReenviarLinkPrimeiroAcessoUsuarioCliente
} from '../../redux/actions/index'
import { elipseVerde, elipseVermelho } from '../../utils/alternanciaIcones'
import decryptJWT from '../../utils/decryptJWT'
import { validadorPermissaoElemento } from '../../utils/verificadorPermissaoElemento'
import MensagemAtencao from '../componentesModais/mensagens/mensagemAtencao'
import MensagemErro from '../componentesModais/mensagens/mensagemErro'
import MensagemSucesso from '../componentesModais/mensagens/mensagemSucesso'
import Table from '../Table/index.jsx'

import CadastroUsuario from './cadastro/cadastro'

import '../../css/painelUsuarios/usuariosPainel.css'

let contador = 0
let controladorPagina = 1
let totalPaginas = 0
let totalItens = 0
let auxDados = []

const TableprimaryKey = 'cd_pav_usuario'

function PainelUsuarios() {
  const [spinAtivo, setSpinAtivo] = useState(true)
  const [itens, setItens] = useState([])
  const [paginaAtual, setPaginaAtual] = useState(1)
  const [renderizar, setRenderizar] = useState(false)
  const [valorLimite] = useState(50)
  const [, setPapeis] = useState([])
  const [, setCdCliente] = useState('')
  const [cdPerfil, setCdPerfil] = useState('')
  const [dsPerfil, setDsPerfil] = useState('')
  const [cdUsuario, setCdUsuario] = useState('')
  const [dsUsuario, setDsUsuario] = useState('')
  const [dsEmail, setDsEmail] = useState('')
  const [dsTelefone, setDsTelefone] = useState('')
  const [dsSobrenomeUsuario, setDsSobrenomeUsuario] = useState('')
  const [flAtivo, setFlAtivo] = useState('')
  const [cdPessoa, setCdPessoa] = useState('')
  const [, setFlCustomizado] = useState('')
  const [dsCpf, setDsCpf] = useState('')
  const [usuarioBloqueio, setUsuarioBloqueio] = useState('')
  const [dsSenha, setDsSenha] = useState('')
  const [isSelect, setIsSelect] = useState(false)
  const [mensagemErro, setMensagemErro] = useState(
    'Ocorreu um erro ao executar esta ação'
  )
  const [revelarMensagemAtencao, setRevelarMensagemAtencao] = useState(false)
  const [revelarMensagemErro, setRevelarMensagemErro] = useState(false)
  const [revelarMensagemSucesso, setRevelarMensagemSucesso] = useState(false)
  const [msgAtencao, setMsgAtencao] = useState(false)
  const [clienteN3, setClienteN3] = useState({
    cadastroN3: false,
    tipoN3: false
  })

  const [itensSelecionados, setItensSelecionados] = useState()

  const despacho = useDispatch()
  let revelarBarraFiltro = useSelector(
    (state) => state.filtrosState.revelarBarraFiltragem
  )
  let conteudoBusca = useSelector((state) => state.manejadorState.conteudoBusca)
  let limpouBuscaGeral = useSelector(
    (state) => state.manejadorState.limpouBusca
  )
  let realizouBuscaGeral = useSelector(
    (state) => state.manejadorState.realizouBusca
  )
  let realizouFiltragem = useSelector(
    (state) => state.manejadorState.realizouFiltro
  )
  let filtros = useSelector((state) => state.filtrosState.filtros)

  let revelarCadastrarUsuario = useSelector(
    (state) => state.virtueyesState.revelarCadastrarUsuario
  )
  let revelarEdicaoUsuario = useSelector(
    (state) => state.virtueyesState.revelarEdicaoUsuario
  )
  let revelarClonarUsuario = useSelector(
    (state) => state.virtueyesState.revelarClonarUsuario
  )
  let excluirUsuarioCliente = useSelector(
    (state) => state.menuUsuarioState.revelarExcluirUsuarioCliente
  )
  let reenviarLinkPrimeiroAcessoUsuarioCliente = useSelector(
    (state) =>
      state.menuUsuarioState.revelarReenviarLinkPrimeiroAcessoUsuarioCliente
  )

  let permissaoElemento = useSelector(
    (state) => state.permissaoState.permissaoElemento
  )

  const [coletaUsabilidade, setColetaUsabilidade] = useState(true)

  useEffect(() => {
    if (coletaUsabilidade) {
      ColetaClickstream(599) // 'painelUsuariosTabela'
      setColetaUsabilidade(false)
    }
    const clienteNivel = decryptJWT('clienteNivel')
    if (clienteNivel === 3) setClienteN3({ cadastroN3: true, tipoN3: true })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    restaurarConfigsIniciaisPagina()
    async function handlerVerificarPermissaoAcao() {
      despacho(
        mudarPermissaoElementoAcao(
          !(await validadorPermissaoElemento(
            permissaoElemento,
            'veye/usuarios/acoes'
          ))
        )
      )
    }
    handlerVerificarPermissaoAcao()
    if (!filtros.vazio) {
      despacho(revelarBarraFiltragem(false))
      despacho(mudarFiltros({ vazio: 'vazio' }))
      despacho(limpadorFiltros(true))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [permissaoElemento])

  if (excluirUsuarioCliente) {
    handleMensagemAtencao(null, false)
    despacho(revelarExcluirUsuarioCliente(false))

    setMsgAtencao({
      handlerConfirmarAtencao: handlerDeletarUsuario,
      titulo: 'Deletar ' + dsUsuario,
      paragrafo1: 'Registros deletados não poderão ser recuperados.'
    })
  }

  if (reenviarLinkPrimeiroAcessoUsuarioCliente) {
    handleMensagemAtencao(null, false)
    despacho(revelarReenviarLinkPrimeiroAcessoUsuarioCliente(false))

    setMsgAtencao({
      handlerConfirmarAtencao: () => handlerReenviarLink(dsEmail),
      titulo: 'Deseja reenviar o link de primeiro acesso?',
      paragrafo1: `O usuário ${dsUsuario} receberá um e-mail com link para cadastrar senha.`
    })
  }

  useEffect(() => {
    setSpinAtivo(true)
    despacho(mudarManejador('usuarioCliente'))

    if (!isSelect) {
      despacho(desabilitarAcoes(true))
      despacho(desabilitarAcoesCliente(true))
    }

    if (limpouBuscaGeral) {
      despacho(limpouBusca(false))
      restaurarConfigsIniciaisPagina()
    }

    if (realizouBuscaGeral) {
      despacho(realizouBusca(false))
      restaurarConfigsIniciaisPagina()
    }

    if (realizouFiltragem) {
      despacho(realizouFiltro(false))
      restaurarConfigsIniciaisPagina()
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [limpouBuscaGeral, realizouBuscaGeral, realizouFiltragem])

  const contarItens = async () => {
    if (controladorPagina > paginaAtual) return 0

    if (filtros.vazio) {
      const { data } = await api_gateway.get(
        `/m1/consultar/usuario?contar="true"&buscar=${encodeURIComponent(
          conteudoBusca
        )}`
      )
      return data?.dados?.[0]?.CONTADOR ?? 0
    } else {
      const dados = {
        paguinaAtual: 0,
        carregarLimit: valorLimite,
        buscar: conteudoBusca,
        filtros,
        cd_pav_usuario_execao: true,
        contar: true
      }
      const { data } = await api_gateway.post('/m1/filtrar/usuario', dados)
      return data?.dados?.[0]?.CONTADOR ?? 0
    }
  }

  useQuery(
    ['painel-usuarios', paginaAtual, valorLimite, filtros, conteudoBusca],
    async () => {
      setSpinAtivo(true)

      const total = await contarItens()
      totalItens = total
      totalPaginas = Math.ceil(totalItens / valorLimite)
      contador = (paginaAtual - 1) * valorLimite

      if (controladorPagina > paginaAtual) return { list: [], item_count: 0 }

      if (filtros.vazio) {
        const { data } = await api_gateway.get(
          `/m1/consultar/usuario?paginaAtual=${contador}&carregarLimit=${valorLimite}&buscar=${encodeURIComponent(
            conteudoBusca
          )}`
        )

        const { paper_data } = await api_gateway.get(
          '/api/v2/papers/read/group'
        )

        setPapeis(paper_data)

        return {
          list: data.dados || [],
          item_count: total
        }
      } else {
        const dados = {
          paguinaAtual: contador,
          carregarLimit: valorLimite,
          buscar: conteudoBusca,
          cd_pav_usuario_execao: true,
          filtros
        }

        const { data } = await api_gateway.post('/m1/filtrar/usuario', dados)

        return {
          list: data.dados || [],
          item_count: total
        }
      }
    },
    {
      onSuccess: async (data) => {
        contador = (paginaAtual - 1) * valorLimite
        totalItens = data?.item_count
        totalPaginas = Math.ceil(totalItens / valorLimite)

        const novosItens = [...auxDados]
        data?.list?.forEach((usuario, index) => {
          novosItens[contador + index] = usuario
        })

        setItens(novosItens)
        setSpinAtivo(false)
      },
      onError: (error) => {
        console.error(error)
        setSpinAtivo(false)
      },
      cacheTime: 0,
      staleTime: 0,
      keepPreviousData: false,
      refetchOnWindowFocus: false,
      retry: false
    }
  )

  function restaurarConfigsIniciaisPagina() {
    totalPaginas = 0
    contador = 0
    controladorPagina = 1
    totalItens = 0
    setPaginaAtual(1)
  }

  const colunas = [
    {
      dataField: 'ds_pav_usuario',
      text: 'Nome',
      sort: true,
      headerClasses: 'tabela-coluna-primeira-header nao-selecionavel',
      formatter: (cell) => {
        return <p className="fonte-cor-1 label-tabela-1">{cell || '-'}</p>
      }
    },
    {
      dataField: 'ds_pav_usuario_sobrenome',
      text: 'Sobrenome',
      sort: true,
      headerClasses: 'nao-selecionavel',
      formatter: (cell) => {
        return <p className="fonte-cor-1 label-tabela-1">{cell || '-'}</p>
      }
    },
    {
      dataField: 'ds_email',
      text: 'E-mail',
      sort: true,
      headerClasses: 'nao-selecionavel',
      formatter: (cell) => {
        return <p className="fonte-cor-1 label-tabela-1">{cell || '-'}</p>
      }
    },
    {
      dataField: 'ds_telefone',
      text: 'Telefone',
      sort: true,
      headerClasses: 'nao-selecionavel',
      formatter: (cell) => {
        return <p className="fonte-cor-1 label-tabela-1">{cell || '-'}</p>
      }
    },
    {
      dataField: 'fl_ativo',
      headerClasses: 'nao-selecionavel',
      text: 'Status',
      sort: true,
      formatter: (cell) => {
        if (cell != null) {
          const isActive = cell === 1 || cell === true
          return (
            <p className="fonte-cor-1 label-tabela-1">
              <Image
                className="img-eclipse-status"
                src={isActive ? elipseVerde() : elipseVermelho()}
              />
              {isActive ? 'Ativo' : 'Inativo'}
            </p>
          )
        }
        return ''
      }
    }
  ]

  async function handlerDeletarUsuario() {
    ColetaClickstream(605) // 'painelUsuariosTabelaDropAcoesExcluirDeletar'
    await api_gateway
      .get(
        '/m1/deletar/usuario?cd_pav_usuario=' +
          cdUsuario +
          '&cd_pav_usuario_deleted=' +
          decryptJWT('codigo')
      )
      .then((response) => {
        if (response.status != 200) {
          setMensagemErro('Ocorreu um erro na deleção de usuario')
          handleMensagemErro(false)
        } else {
          handleMensagemSucesso(false)
        }
      })
      .catch(() => {
        setMensagemErro('Ocorreu um erro na deleção de usuario')
        handleMensagemErro(false)
      })
    setItens([])
    setRenderizar(!renderizar)
  }

  async function handlerReenviarLink(emailReenvio) {
    api_gateway.get(
      `/m1/servicos/token/email_primeiro_acesso?ds_email=${emailReenvio.trim()}`
    )
  }

  function handleMensagemErro() {
    if (revelarMensagemErro === false) {
      setRevelarMensagemErro(true)
    } else {
      setRevelarMensagemErro(false)
    }
  }

  function handleMensagemAtencao(handleConfirmarAtencao, confirmacao) {
    if (revelarMensagemAtencao === false) {
      setRevelarMensagemAtencao(true)
    } else {
      setRevelarMensagemAtencao(false)
      if (confirmacao === true) {
        handleConfirmarAtencao()
      } else if (
        msgAtencao?.titulo.includes('Deletar') ||
        excluirUsuarioCliente
      ) {
        ColetaClickstream(1265) // 'painelUsuariosTabelaDropAcoesExcluirCancelar'
      }
    }
  }

  function handleMensagemSucesso(confirmacao) {
    if (revelarMensagemSucesso === false) {
      setRevelarMensagemSucesso(true)
    } else {
      setRevelarMensagemSucesso(false)
      if (confirmacao === true) {
        setRenderizar(!renderizar)
      }
    }
    setRenderizar(!renderizar)
  }

  const handleOnSelect = (row, isSelect) => {
    setIsSelect(isSelect)

    if (isSelect) {
      setItensSelecionados(row)

      setCdCliente(row.cd_pav_cliente)
      setCdPerfil(row.cd_pav_perfil)
      setDsPerfil(row.ds_pav_perfil)
      setCdUsuario(row.cd_pav_usuario)
      setDsUsuario(row.ds_pav_usuario)
      setDsSobrenomeUsuario(row.ds_pav_usuario_sobrenome)
      setDsTelefone(row.ds_telefone)
      setDsEmail(row.ds_email)
      setFlAtivo(row.fl_ativo)
      setFlCustomizado(row.fl_customizado)
      setCdPessoa(row.cd_pav_pessoa)
      setDsCpf(row.ds_cpf)
      setUsuarioBloqueio(row.usuario_bloqueio)
      setDsSenha(row.ds_senha)

      despacho(desabilitarAcoes(false))
    }
  }

  const getLimiteNaPagina = () =>
    contador + valorLimite <= totalItens ? contador + valorLimite : totalItens
  const getTotalItensNaPagina = () => getLimiteNaPagina()

  const trocarPagina = (novaPagina) => {
    if (totalPaginas <= 1) return

    setPaginaAtual(novaPagina)
  }

  const itensSelecionadosTable = itensSelecionados?.[TableprimaryKey]
    ? [itensSelecionados[TableprimaryKey]]
    : []

  return (
    <>
      <Table
        keyField={TableprimaryKey}
        clickToSelect
        revelarContador
        itens={itens}
        colunas={colunas}
        revelarBarraFiltro={revelarBarraFiltro}
        getTotalItensNaPagina={getTotalItensNaPagina}
        getLimiteNaPagina={getTotalItensNaPagina}
        pagination={{
          paginaAtual,
          valorLimite,
          totalPaginas,
          totalItens,
          contador,
          trocarPagina
        }}
        selection={{
          itensSelecionados: itensSelecionadosTable,
          modeSelection: 'radio',
          handleOnSelect
        }}
      />

      {spinAtivo && (
        <div className="componente-spinner-overlay">
          <div className="componente-spinner-container">
            <SpinerVeye />
          </div>
        </div>
      )}
      {revelarCadastrarUsuario && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <CadastroUsuario
              tituloJanela="Cadastrar"
              renderizar={renderizar}
              setRenderizar={setRenderizar}
              cadastroN3={clienteN3.cadastroN3}
              tipoN3={clienteN3.tipoN3}
            />
          </div>
        </div>
      )}
      {revelarEdicaoUsuario && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <CadastroUsuario
              tituloJanela="Editar"
              renderizar={renderizar}
              setRenderizar={setRenderizar}
              cdUsuario={cdUsuario}
              dsNome={dsUsuario}
              dsSobrenome={dsSobrenomeUsuario}
              dsCpf={dsCpf}
              dsTelefone={dsTelefone}
              dsEmail={dsEmail}
              flAtivo={flAtivo}
              dsSenha={dsSenha}
              cdPerfil={cdPerfil}
              dsPerfil={dsPerfil}
              cdPessoa={cdPessoa}
              usuarioBloqueio={usuarioBloqueio}
            />
          </div>
        </div>
      )}
      {revelarClonarUsuario && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <CadastroUsuario
              tituloJanela="Clonar"
              renderizar={renderizar}
              setRenderizar={setRenderizar}
              cdUsuario={cdUsuario}
              dsNomeOriginal={dsUsuario}
            />
          </div>
        </div>
      )}

      {revelarMensagemSucesso && (
        <MensagemSucesso
          handleMensagemSucesso={handleMensagemSucesso}
          mensagemTitulo="Sucesso"
          mensagemParagrafo1={'Usuario ' + dsUsuario + ' deletado.'}
          mensagemBotao="Continuar"
        />
      )}
      {revelarMensagemErro && (
        <MensagemErro
          handleMensagemErro={handleMensagemErro}
          mensagemTitulo={mensagemErro}
          mensagemParagrafo1="Erro"
          mensagemParagrafo2={mensagemErro}
          mensagemBotao="Retornar"
        />
      )}
      {revelarMensagemAtencao && (
        <MensagemAtencao
          handleMensagemAtencao={(v) =>
            handleMensagemAtencao(msgAtencao.handlerConfirmarAtencao, v)
          }
          mensagemTitulo={msgAtencao.titulo}
          mensagemParagrafo1={msgAtencao.paragrafo1}
          mensagemBotao="Confirmar"
        />
      )}
    </>
  )
}

function mapStateToProps(state) {
  return {
    conteudoBusca: state.manejadorState.conteudoBusca,
    filtros: state.filtrosState.filtros
  }
}

export default connect(mapStateToProps)(React.memo(PainelUsuarios))
